import React from 'react'
import { Button } from '../ButtonElement'
import eventImg from '../../images/kofc_r_emblem_rgb_pos.png'
import { data } from './officerData'
import Table from './tableBuilder'
import { 
    InfoContainer, 
    InfoWrapper, 
    InfoRow, 
    Column1, 
    Column2,
    TextWrapper, 
    TopLine, 
    Heading, 
    Subtitle, 
    BtnWrap, 
    ImgWrap, 
    Img,
    TextWrapper2,
    TopLine2,
    Heading2,
    Subtitle2,
    eventTable
} from './OfficerElements'
const OfficersSection = ({lightBg,id,imgStart, topLine, lightText, headline, darkText, description, buttonLabel, img, alt, primary, dark, dark2}) => {
  return (
    <>
        <InfoContainer  id='officers'>
            <InfoWrapper>
                <InfoRow>
                    <Column1>
                        <TextWrapper>
                            <TopLine>Officers</TopLine>
                            <Heading>Council 460 Officers</Heading>
                            <Table data={data}/>
                        </TextWrapper>
                    </Column1>
                   
               
                       
                </InfoRow>
            </InfoWrapper>

        </InfoContainer>
    </>
  )
}

export default OfficersSection
